import React, { useCallback, useState, useEffect, useRef } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { withWindowSizeListener } from 'react-window-size-listener'
import '../styles/components/ImageGridPhotos.css'

const ImageGridPhotos = ({ photos, windowSize: { windowWidth } }) => {
  const renderPhotos = useCallback(() => {
    const [imageWidth, setImageWidth] = useState(0)
    const imageRef = useRef(null)

    /*
      listen the window width, when the window width changes, update
      the image width to calculate the new height based on the new width

      obs: similar to aspect-ratio property
    */
    useEffect(() => {
      setImageWidth(imageRef.current.offsetWidth)
    }, [windowWidth])

    return photos.map(({ photo, id, onClick }) => {
      return (
        <div ref={imageRef} key={id} className='imagegridphotos-item'
          onClick={onClick} style={{ height: imageWidth }} >
          <LazyLoadImage src={photo} effect='blur'
            width='100%'
            height='100%'
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }} />
        </div>
      )
    })
  }, [photos, windowWidth])

  return (
    <div className='imagegridphotos-container'>
      {renderPhotos()}
    </div>
  )
}

export default withWindowSizeListener(ImageGridPhotos)



// WEBPACK FOOTER //
// ./src/components/ImageGridPhotos.js